import useLoggedInUser from './useLoggedInUser'
import { Locale } from '@/types'
import { NumericFormatProps } from 'react-number-format'

export const localeSettings: Partial<Record<Locale, NumericFormatProps>> = {
  da_DK: {
    decimalSeparator: ',',
    thousandSeparator: '.',
    thousandsGroupStyle: 'thousand',
  },
  en_US: {
    decimalSeparator: '.',
    thousandSeparator: ',',
    thousandsGroupStyle: 'thousand',
  },
  sv_SE: {
    decimalSeparator: ',',
    thousandSeparator: ' ',
    thousandsGroupStyle: 'thousand',
  },
  de_DE: {
    decimalSeparator: ',',
    thousandSeparator: '.',
    thousandsGroupStyle: 'thousand',
  },
  fr_FR: {
    decimalSeparator: ',',
    thousandSeparator: ' ',
    thousandsGroupStyle: 'thousand',
  },
  ja_JP: {
    decimalSeparator: '.',
    thousandSeparator: ',',
    thousandsGroupStyle: 'wan',
  },
  nn_NO: {
    decimalSeparator: ',',
    thousandSeparator: '.',
    thousandsGroupStyle: 'thousand',
  },
  nb_NO: {
    decimalSeparator: ',',
    thousandSeparator: '.',
    thousandsGroupStyle: 'thousand',
  },
  pl_PL: {
    decimalSeparator: ',',
    thousandSeparator: ' ',
    thousandsGroupStyle: 'thousand',
  },
  fi_FI: {
    decimalSeparator: ',',
    thousandSeparator: ' ',
    thousandsGroupStyle: 'thousand',
  },
}

const useLocaleSettings = (
  localeInput?: Locale,
): Partial<NumericFormatProps | undefined> => {
  const { locale }: { locale: Locale } = useLoggedInUser()

  return localeSettings[localeInput || locale] || localeSettings.en_US
}

export default useLocaleSettings
